import classNames     from 'classnames';
import * as PropTypes from 'prop-types';
import * as React     from 'react';

import { useSidebar } from '../../../providers/sidebar';

const BaseSidebar = function(props) {
  const {
          btnClose,
          children,
          customClass,
          open,
          position,
          title,
        } = props;

  const sidebar = useSidebar();

  const sidebarRef = React.useRef(null);

  const [isOpen, setIsOpen] = React.useState(false);

  const handleClickOutside = React.useCallback((event) => {
    if (isOpen && (sidebarRef.current && !sidebarRef.current.contains(event.target))) {
      sidebar.hideSidebar();
    }
  }, [isOpen]);
  const handleKeyDown      = React.useCallback((event) => {
    if (event.key === 'Escape' && isOpen) {
      sidebar.hideSidebar();
    }
  }, [isOpen]);

  React.useEffect(() => {
    if (open !== isOpen) {
      setIsOpen(open);
    }
  }, [open]);
  React.useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  if (!open) {
    return null;
  }

  return (
    <aside
      className={classNames(`sidebar sidebar-${position}`, customClass, { 'open': isOpen })}
      ref={sidebarRef}
    >
      {btnClose && (
        <div className={'top'}>
          {customClass
            ? (
              <span
                className={'closeBtn'}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  sidebar.hideSidebar();
                }}
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <circle
                  cx="8"
                  cy="8"
                  r="8"
                  fill="#488EC8"
                />
                <path
                  d="M11 5L5 11M5 5L11 11"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            )
            : (
              <span
                className="ic-close"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  sidebar.hideSidebar();
                }}
              />
            )
          }
        </div>
      )}
      {typeof title === 'string' && <div className={'title'}>{title}</div>}
      {children}
    </aside>
  );
};

BaseSidebar.defaultProps = {
  position: 'right',
  btnClose: true,
};

BaseSidebar.propTypes = {
  position: PropTypes.string,
  btnClose: PropTypes.bool,
};

export default BaseSidebar;